module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Black.e34322d.woff2";